<template>
   <div class="dashboards">
      <Delete :delete_message="delete_message" :show="show_delete_modal" @close="$store.commit('show_delete_modal',false)" @delete="deleteDashboard()"/>

      <Modal :show="show_create_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_create_modal',false)">
         <template slot="title">
            <div class="title">{{DashboardModel.forms.addDashboard.title}}</div>
            <div class="subtitle">{{DashboardModel.forms.addDashboard.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="DashboardModel.forms.addDashboard.name" 
                  :forms="DashboardModel.forms.addDashboard.forms" 
                  :form_data="DashboardModel.forms.addDashboard.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="addDashboard({ref: $refs[DashboardModel.forms.addDashboard.name]})" :disabled="loading">
                     Create <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <Modal :show="show_edit_modal" content_class="col-12 col-md-7 col-lg-6 col-xl-5" @close="$store.commit('show_edit_modal',false)">
         <template slot="title">
            <div class="title">{{DashboardModel.forms.editDashboard.title}}</div>
            <div class="subtitle">{{DashboardModel.forms.editDashboard.subtitle}}</div>
         </template>
         <template slot="content">
            <div>
               <Form 
                  class_binding="row" 
                  :ref="DashboardModel.forms.editDashboard.name" 
                  :forms="DashboardModel.forms.editDashboard.forms" 
                  :form_data="DashboardModel.forms.editDashboard.data"
               />
               <div class="btns clearfix">
                  <div class="btn btn-primary btn-r" @click="updateDashboard({ref: $refs[DashboardModel.forms.editDashboard.name]})" :disabled="loading">
                     Save <div class="lds-ring" v-show="loading"><div></div><div></div><div></div><div></div></div>
                  </div>
               </div>
            </div>
         </template>
      </Modal>

      <div class="top-actions clearfix">
         <div class="btn btn-primary btn-r" @click="$store.commit('show_create_modal',true)">
            Add Dashboard <i class="fa fa-plus"></i>
         </div>
      </div>
      
      <Table v-bind="DashboardModel.tables.dashboard.props" :data="dashboards" @on-action="handleActions">
         <template slot-scope="{ row }" slot="date">
            <strong class="tx-small">{{ moment(row.last_update).format('DD-MM-YYYY HH:mm') }}</strong>
         </template>
         <template slot-scope="{ row }" slot="visual_count">{{row.visuals.length}}</template>
      </Table>
   </div>
</template>

<script>
import dashboard from "./dashboard.store";

export default {
   beforeDestroy () {
      this.$store.unregisterModule('dashboard')
   },
   created(){
      Event.$emit('loader:show',true)
      utils.registerModule('dashboard',dashboard,this.$store)
   },
   components:{
      Delete: () => import("wino-template/components/delete"),
      Modal: () => import("wino-template/components/modal"),
      Form: () => import("clarks/components/form"),
      Table: () => import("clarks/components/ivu-table"),
   },
   data (){
      return {
         moment,
      };
   },
   computed: {
      ...mapGetters([
         'DashboardModel',
         'dashboards',
         'show_create_modal',
         'show_edit_modal',
         'show_delete_modal',
         'loading',
         'delete_message',
      ])
   },
   methods: {
      ...mapActions([
         'fetchData',
         'addDashboard',
         'deleteDashboard',
         'updateDashboard',
         'handleActions',
      ]),
   },
   async mounted(){
      utils.registerModule('dashboard',dashboard,this.$store)
      await this.fetchData()
   }
}
</script>

<style lang="scss">
   .dashboards{
      .tx-small{
         font-size: 12px;
      }
   }
</style>